
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telecommuting",
      function () {
        return require("private-next-pages/telecommuting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telecommuting"])
      });
    }
  